var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "journey-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-radio-group",
            {
              staticStyle: { margin: "16px 0" },
              attrs: { size: "mini" },
              on: { change: _vm.reload },
              model: {
                value: _vm.behaviorType,
                callback: function ($$v) {
                  _vm.behaviorType = $$v
                },
                expression: "behaviorType",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "" } }, [_vm._v("全部")]),
              _c("el-radio-button", { attrs: { label: "view" } }, [
                _vm._v("浏览"),
              ]),
              _c("el-radio-button", { attrs: { label: "favorite" } }, [
                _vm._v("收藏"),
              ]),
              _c("el-radio-button", { attrs: { label: "like" } }, [
                _vm._v("赞过"),
              ]),
              _c("el-radio-button", { attrs: { label: "reward" } }, [
                _vm._v("赏过"),
              ]),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "behavior.behaviorNo",
                  label: "编号",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "behavior.behaviorType",
                  label: "类型",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "behavior.objectType",
                  label: "对象",
                  width: "90",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "behavior.objectId",
                  label: "对象ID",
                  width: "90",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "behavior.followStatus",
                  label: "跟进",
                  width: "90",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("MY JOURNEY")]),
        _c("h2", [_vm._v("我的历程")]),
        _c("p", [_vm._v("按行为类型查看客户浏览收藏与到访。")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }